import { render, staticRenderFns } from "./PmSurya.vue?vue&type=template&id=0867930e&scoped=true&"
import script from "./PmSurya.vue?vue&type=script&lang=js&"
export * from "./PmSurya.vue?vue&type=script&lang=js&"
import style0 from "./PmSurya.vue?vue&type=style&index=0&id=0867930e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0867930e",
  null
  
)

export default component.exports